export default "__VITE_ASSET__D91mQckN__$_?nuxt_component=async&nuxt_component_name=SvgoFuturesPauseDark&nuxt_component_export=default__"